import { ContentChild, Directive, ElementRef, Input } from '@angular/core';
import { NxReorderHandleDirective } from './nx-reorder-handle.directive';

/**
 * Marks a single sortable row within an `[nxReorderList]` (equivalent to `cdkDrag`).
 * Its index is derived from its position in the list, so no index input is needed.
 */
@Directive({
  selector: '[nxReorderItem]'
})
export class NxReorderItemDirective {
  /** Disables dragging for this single row. */
  @Input() nxReorderItemDisabled = false;

  @ContentChild(NxReorderHandleDirective) private handle?: NxReorderHandleDirective;

  constructor(public readonly elementRef: ElementRef<HTMLElement>) {}

  /** Element that starts the drag: the handle if present, otherwise the whole row. */
  get dragHandleElement(): HTMLElement {
    return this.handle?.elementRef.nativeElement ?? this.elementRef.nativeElement;
  }
}
